import { components } from 'type/ReportServiceSchema';
import { InsightsOptionModel } from 'api/dto/new/Common/InsightsOption.dto';
import {
  InsightsByGroupModel,
  mapInsightsByGroupDtoToModel,
} from 'api/dto/new/InsightsCompared/InsightsByGroup.dto';
import { RespondentProtectionEnumNullable } from 'model/RespondentProtection';

export type InsightsAnswerDto = components['schemas']['AnswerDTO2'];

export type InsightsAnswerModel = Readonly<{
  option: InsightsOptionModel;
  byGroup: Readonly<Record<string, InsightsByGroupModel>>;
}>;

export const mapInsightsAnswerDtoToModel = (
  dto: InsightsAnswerDto,
  protections: Record<string | number, RespondentProtectionEnumNullable>
): InsightsAnswerModel => ({
  option: dto.option,
  byGroup: Object.fromEntries(
    Object.entries(dto.byGroup).map(([key, byGroupDto]) => [
      key,
      mapInsightsByGroupDtoToModel(byGroupDto, protections[key]),
    ])
  ),
});
